const User = ({user, size = 30}) => {
    // console.log(user);
    return (
        <div className="inline-flex gap-2 items-center">
            {/* <img className="avatar" width={size} height={size} src={user.avatar} alt="Avatar" /> */}
            {user.firstname} {user.name}
        </div>
    )
}

export default User;